
import React, {Component} from 'react'
import {Box} from 'reactjs-admin-lte'
import {Button,Modal,FormGroup,Form} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import { Radio } from 'react-icheck'
import FixingOrderDoc from './FixingOrderDoc'
import FontAwsome from 'react-fontawesome'
// import DatePicker from 'component/element/DatePicker'
import NewContractorModal from '../../hr/NewContractorModal'
import EmployeeModal from '../../hr/EmployeeModal'
import WorkdocStore from '../../../stores/WorkdocStore'
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system');
class WorkJobEmployeeTable extends Component {

  constructor(...args){
    super(...args)

    this.state = ({ 
      loading:false,
      show:false,
      defaultRadio:'',
      radioType:[false,false],
      showWorkJobEmp:'',
      showFixing:false,
      showContractorModal:false,
      showEmployeeModal:false,
      data:[],
      workNo:'',
      technician:{},
      _employee_id:'',
      _first_name:'',
      _last_name:'',
      _nick_name:'',
      _position:'',
      isJobTime:false
    })
  }

  componentDidMount(){
    
  }

  loadData(workNo){
    this.setState({workNo:workNo})
    let that = this
    WorkdocStore.loadWorkdocFixingOrderList(workNo,function(result){
      that.setState({data:result.data})
    },function(error){

    })
  }

  onJobEmployeeClick(item,workNo) {
    let {data} = this.state
    data.push(item)
    this.setState({data:data,workNo:workNo,isJobTime:true},()=>{
      this.onRowClick(item)
    })
  }

  onRowClick(item,e) {
    this.setState({showWorkJobEmp:'none',showFixing:true,technician:item})    
  }

  onCloseClick(){
    let {radioType,defaultRadio} = this.state
    radioType[0] = false
    radioType[1] = false
    defaultRadio = ''
    this.setState({show:false,radioType:radioType,defaultRadio:defaultRadio})
  }

  onOpenClick() {
    // let {show} = this.state
    this.setState({show:true})
  }

  onRadioChange(key,e) {
    let {radioType,defaultRadio} = this.state
    let {showContractorModal,showEmployeeModal} = this.state
    if (key==='out') {
      radioType[0] = true
      radioType[1] = false
      defaultRadio = 'out'
      showContractorModal = true
      showEmployeeModal = false
    } else if (key==='in') {
      radioType[0] = false
      radioType[1] = true
      defaultRadio = 'in'
      showContractorModal = false
      showEmployeeModal = true
    }  
    this.setState({radioType:radioType,defaultRadio:defaultRadio,showContractorModal:showContractorModal,showEmployeeModal:showEmployeeModal})  

    
  }   

  onSaveClick(e){
    let {defaultRadio,showContractorModal,showEmployeeModal} = this.state
    if (defaultRadio=='out') {
      showContractorModal = true
      showEmployeeModal = false
    } else if (defaultRadio=='in') {
      showContractorModal = false
      showEmployeeModal = true
    }
    this.setState({showContractorModal:showContractorModal,showEmployeeModal:showEmployeeModal})
  }

  onSelect(item) {
    let {data,defaultRadio,radioType} = this.state
    item = Object.assign({count_list:'',end_job_date:'',fixing_order_date:'',gross_flag:'',man_hour:'0',start_job_date:'',sum_cost:'0',work_status:''},item)
    data.push(item)
    radioType[0] = false
    radioType[1] = false
    defaultRadio = ''
    this.setState({data:data,show:false,radioType:radioType,defaultRadio:defaultRadio})
    this.onRowClick(item)
  }

  onResetDisplay(completeFunc=undefined) {
    this.setState({showWorkJobEmp:'',showFixing:false},()=>{
      if (completeFunc!==undefined)
        completeFunc()
    })
  }

  onFixingBack(e) {
    let {workNo,isJobTime} = this.state
    if (isJobTime) {
      this.onResetDisplay(()=>{
        if (this.props.onJobTimeBack!==undefined) {
          this.props.onJobTimeBack(()=>{
            this.setState({isJobTime:false})
          })
        }
      })  
    } else {
      this.loadData(workNo,()=>{
        this.onResetDisplay(()=>{
          this.setState({isJobTime:false})
        })
      })
    }  
  }

  renderEmployeeType(workStatus){
    let {messages} = this.props
    if(workStatus==='contractor'){
      return (<span>{messages['Contractor']}</span>)
    }else{
      return (<span>{messages['Employee']}</span>)
    }
  }

  onDateChange(item) { 
    let {data,technician} = this.state
    let dataIndex = undefined
    data.forEach((item,index)=>{
      if (item.employee_id===technician.employee_id)
        dataIndex = index 
    })

    if (dataIndex!==undefined) {
      data[dataIndex].fixing_order_date = item.value
      this.setState({data:data})
    }  
  }

  onManHourChange(item) { 
    let {data,technician} = this.state
    let dataIndex = undefined
    data.forEach((item,index)=>{
      if (item.employee_id===technician.employee_id)
        dataIndex = index 
    })

    if (dataIndex!==undefined) {
      data[dataIndex].man_hour = item.value
      this.setState({data:data})
    }  
  }
  
  onJobDateChange(items) {
    let {data,technician} = this.state
    let dataIndex = undefined
    data.forEach((item,index)=>{
      if (item.employee_id===technician.employee_id)
        dataIndex = index 
    })

    if (dataIndex!==undefined) {
      data[dataIndex][items.field] = items.value
      this.setState({data:data})
    }
  }

  renderRowData(){
    let {data} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={11}>{this.props.messages['No Data']}</td></tr>)
    } else {
      return(
        data.map((item,index) => {
          return(
            <tr key={index}>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{index+1}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.fixing_order_date}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{this.renderEmployeeType(item.work_status)}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.first_name}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.last_name}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.nick_name}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.position}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.start_job_date}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.end_job_date}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.sum_cost}</td>
              <td className='text-center' onClick={this.onRowClick.bind(this,item)}>{item.count_list}</td>
            </tr>
          )
        })
      )
    }
  }

  renderTable(){
    let {messages} = this.props
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>{messages['No']}</th>
            <th className='text-center' style={{width:'70px'}}>{messages['Date']}</th>
            <th className='text-center' style={{width:'30px'}}>{messages['Type']}</th>
            <th className='text-center' style={{width:'100px'}}>{messages['First Name']}</th>
            <th className='text-center' style={{width:'100px'}}>{messages['Surname']}</th>
            <th className='text-center' style={{width:'70px'}}>{messages['Nickname']}</th>
            <th className='text-center' style={{width:'70px'}}>{messages['Position']}</th>
            <th className='text-center' style={{width:'120px'}}>{messages['Start Job Date']}</th>
            <th className='text-center' style={{width:'120px'}}>{messages['End Job Date']}</th>
            <th className='text-center' style={{width:'70px'}}>{messages['Wage']}</th>
            <th className='text-center' style={{width:'70px'}}>{messages['Task List']}</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
      </table>
    )
  }

  onUpdateTec(technician) {
    this.setState({_employee_id:technician.employee_id,_first_name:technician.first_name,_last_name:technician.last_name,_nick_name:technician.nick_name,_position:technician.position})    
  }

  render(){
    let {loading,show,radioType,showFixing,showWorkJobEmp,showContractorModal,showEmployeeModal} = this.state
    let {messages} = this.props
    return (
      <div>
        <div style={{display:showWorkJobEmp}}>
          <Box loading={loading}>
            <Box.Header  className='text-center'>
              <Box.Title>
                          
              </Box.Title> 
              <Box.Tools>
                <Button className='bg-olive' onClick={this.onOpenClick.bind(this)}>
                  <FontAwsome name='plus' />&nbsp;{messages['Add Item']}
                </Button>
              </Box.Tools>
            </Box.Header>
            <Box.Body>
              {this.renderTable()}
              <NewContractorModal
                show={showContractorModal}
                onHide={()=>{this.setState({showContractorModal:false})}}
                onSelect={this.onSelect.bind(this)}
              >
              </NewContractorModal>
              <EmployeeModal
                show={showEmployeeModal}
                onHide={()=>{this.setState({showEmployeeModal:false})}}
                onSelect={this.onSelect.bind(this)}
              >
              </EmployeeModal>
              <NotificationSystem ref="notificationSystem" /> 
              <Modal show={show} onHide={this.onCloseClick.bind(this)}>
                <Modal.Header closeButton>
                  <Modal.Title>
                    {messages['Responsible Person']}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <FormGroup>
                      <Radio
                        checked={radioType[0]}
                        radioClass="iradio_square-blue"
                        increaseArea="20%"
                        label={' '+messages['Contractor']}
                        onChange={this.onRadioChange.bind(this,'out')}
                      >
                      </Radio>
                      {' '}
                      <Radio
                        checked={radioType[1]}
                        radioClass="iradio_square-blue"
                        increaseArea="20%"
                        label={' '+messages['Employee']}
                        onChange={this.onRadioChange.bind(this,'in')}
                      >
                      </Radio>
                    </FormGroup>
                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  
                  <Button className="btn-default" onClick={this.onCloseClick.bind(this)}>
                    <FontAwesome name='remove' />&nbsp;{messages['Close']}
                  </Button>            
                </Modal.Footer>  
              </Modal>      
            </Box.Body>
          </Box>
        </div>
        
          <FixingOrderDoc   
            show={showFixing}         
            workNo={this.state.workNo}
            onBack={this.onFixingBack.bind(this)}
            technician={this.state.technician}
            _employee_id={this.state.technician.employee_id}
            _first_name={this.state.technician.first_name}
            _last_name={this.state.technician.last_name}
            _nick_name={this.state.technician.nick_name}
            _position={this.state.technician.position}
            isJobTime={this.state.isJobTime}
            onUpdateTec={this.onUpdateTec.bind(this)}
            onDateChange={this.onDateChange.bind(this)}
            onJobDateChange={this.onJobDateChange.bind(this)}
            onManHourChange={this.onManHourChange.bind(this)}
          >
          </FixingOrderDoc>
        
      </div>  
    )
  }
}

export default WorkJobEmployeeTable = connect(
  (state) => ({messages: state.message.view.workdoc.jobcontrol.WorkJobEmployeeTable}),null,null,{withRef:true}
)(WorkJobEmployeeTable);




// WEBPACK FOOTER //
// ./src/view/workdoc/jobcontrol/WorkJobEmployeeTable.js